<template>
<!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<g>
	<g>
		<path d="M270.34,173.62H76.083c-4.142,0-7.501,3.358-7.501,7.501s3.358,7.501,7.501,7.501H270.34c4.143,0,7.501-3.358,7.501-7.501
			S274.483,173.62,270.34,173.62z"/>
	</g>
</g>
<g>
	<g>
		<path d="M270.34,222.819H76.083c-4.142,0-7.501,3.358-7.501,7.501s3.358,7.501,7.501,7.501H270.34
			c4.143,0,7.501-3.358,7.501-7.501S274.483,222.819,270.34,222.819z"/>
	</g>
</g>
<g>
	<g>
		<path d="M270.34,272.019H76.083c-4.142,0-7.501,3.358-7.501,7.501s3.358,7.501,7.501,7.501H270.34
			c4.143,0,7.501-3.358,7.501-7.501S274.483,272.019,270.34,272.019z"/>
	</g>
</g>
<g>
	<g>
		<path d="M497.907,85.024c10.535-19.007,4.048-43.137-14.786-54.229l-7.77-4.575c-19.142-11.271-43.884-4.87-55.154,14.271
			l-73.771,125.277v-36.931c0-1.906-0.742-3.843-2.188-5.295c-0.003-0.003-0.005-0.007-0.008-0.01
			c-2.147-2.147-96.884-96.883-99.031-99.03c-1.354-1.355-3.298-2.197-5.304-2.197h-49.103c-4.142,0-7.501,3.358-7.501,7.501
			s3.358,7.501,7.501,7.501h41.602v79.997c0,10.495,8.539,19.033,19.034,19.033h79.996v79.633l-61.978,105.247H76.083
			c-4.142,0-7.501,3.358-7.501,7.501c0,4.142,3.358,7.501,7.501,7.501H260.61c-5.709,9.693-9.053,15.373-14.879,25.268
			c-2.102,3.569-2.688,7.745-1.65,11.755c0.613,2.371,1.762,4.508,3.328,6.301l-14.666,24.904c-5.6,9.51-2.418,21.802,7.09,27.402
			l2.795,1.646c9.498,5.592,21.804,2.416,27.403-7.091l14.625-24.836c2.472,0.564,4.886,0.489,7.192-0.108
			c3.941-1.02,7.251-3.514,9.317-7.023l30.258-51.381v129.255c0,2.185-1.847,4.031-4.032,4.031H19.033
			c-2.185,0-4.031-1.846-4.031-4.031V47.892c0-5.837,4.748-10.585,10.585-10.585h130.201c4.142,0,7.501-3.358,7.501-7.501
			s-3.358-7.501-7.501-7.501H25.587C11.478,22.306,0,33.784,0,47.892v424.419c0,10.495,8.539,19.033,19.033,19.033H327.39
			c10.495,0,19.034-8.538,19.034-19.033V317.583l15.876-26.959c2.102-3.569,0.912-8.168-2.657-10.27
			c-3.568-2.1-8.166-0.912-10.27,2.657c-6.82,11.581-53.793,91.348-60.596,102.899c-0.37,0.626-1.171,0.824-1.788,0.46
			c-0.804-0.474-26.853-15.814-27.204-16.021c-0.763-0.45-1.018-1.437-0.568-2.201c2.967-5.039,91.792-155.876,96.634-164.097
			l29.715,17.499l-18.408,31.26c-2.102,3.569-0.912,8.168,2.657,10.27c3.569,2.102,8.167,0.912,10.27-2.657l18.575-31.543
			c1.648,0.561,3.351,0.833,5.041,0.833c5.399,0,10.666-2.775,13.6-7.756l72.717-123.483c7.973,9.47,9.386,23.248,2.876,34.303
			l-50.03,84.957c-2.102,3.569-0.912,8.168,2.657,10.27c3.568,2.1,8.166,0.914,10.27-2.657l50.03-84.957
			C516.511,122.234,512.988,99.175,497.907,85.024z M251.427,121.336c-2.186,0-4.032-1.846-4.032-4.031V47.915l73.42,73.42H251.427z
			 M259.929,387.848l11.434,6.734l-14.259,24.212c-1.378,2.34-4.521,3.154-6.864,1.776l-2.795-1.646
			c-2.341-1.379-3.154-4.522-1.775-6.864L259.929,387.848z M484.465,78.338l-80.094,136.009c-0.21,0.355-0.67,0.474-1.026,0.267
			l-50.238-29.585c-0.047-0.028-0.189-0.111-0.244-0.324c-0.056-0.213,0.028-0.355,0.057-0.403l80.203-136.199
			c7.076-12.016,22.607-16.029,34.615-8.957l7.77,4.576C487.522,50.795,491.539,66.325,484.465,78.338z"/>
	</g>
</g>
<g>
	<g>
		<path d="M216.719,402.791l-18.37-14.152c-4.014-3.092-9.727-2.948-13.577,0.34l-11.348,9.685l-24.257-22.819
			c-4.602-4.329-11.696-4.5-16.502-0.4l-32.328,27.583c-3.151,2.688-3.526,7.423-0.837,10.575c2.689,3.152,7.422,3.524,10.574,0.836
			l30.533-26.051l24.023,22.599c4.735,4.456,12.035,4.632,16.981,0.412l10.295-8.787l15.658,12.063
			c3.284,2.529,7.992,1.915,10.52-1.364C220.611,410.029,220,405.319,216.719,402.791z"/>
	</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
</template>
